module.exports = __webpack_public_path__ + "img/kukimi.0b55a368.jpg";